import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { KdsFilterBar, type KdsOrderFilter } from "./KdsFilterBar";
import { ArrowLeft, Wifi, WifiOff } from "lucide-react";

interface KdsTopBarProps {
  stationName: string;
  activeFilter: KdsOrderFilter;
  onFilterChange: (filter: KdsOrderFilter) => void;
  ticketCount: number;
}

export function KdsTopBar({ stationName, activeFilter, onFilterChange, ticketCount }: KdsTopBarProps) {
  const navigate = useNavigate();
  const [clock, setClock] = useState(new Date());
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const interval = setInterval(() => setClock(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <div className="flex items-center justify-between px-4 py-3 bg-zinc-800 border-b border-zinc-700 shrink-0">
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate("/kds/select-station")}
          className="p-2 rounded-lg hover:bg-zinc-700 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 text-zinc-400" />
        </button>
        <h1 className="text-lg font-bold text-white">{stationName}</h1>
        <span className="text-xs bg-zinc-700 text-zinc-300 px-2 py-0.5 rounded-full font-medium">
          {ticketCount} pedido{ticketCount !== 1 ? "s" : ""}
        </span>
      </div>

      <div className="flex items-center gap-4">
        <KdsFilterBar activeFilter={activeFilter} onFilterChange={onFilterChange} />
        
        <div className="flex items-center gap-2">
          {online ? (
            <Wifi className="w-4 h-4 text-emerald-400" />
          ) : (
            <WifiOff className="w-4 h-4 text-red-400" />
          )}
          <span className="text-sm font-mono text-zinc-400 tabular-nums">
            {clock.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
          </span>
        </div>
      </div>
    </div>
  );
}
